module.exports = "https://deal-img.imgix.net/consumer/modern/croatia.904a3121.jpg";